// extracted by mini-css-extract-plugin
module.exports = {"block-reasons-form__item":"_3K8F_xWGG8AMXVhHpt_jXp"};